import React from 'react';
import { t } from '../i18n';
import { isISR } from './countriesHelpers';

export const getStateAndZipLabel = () => {
  return isISR() ? t('dash.common.location.postal_code') : t('dash.common.location.state_postal_code_title');
};

export const getStateAndZip = ({ zip, state }: { zip: string; state: string }) => {
  const zipValue = zip || t('dash.common.aliases.n/a');

  if (isISR()) {
    return zipValue;
  }

  return `${state || t('dash.common.aliases.n/a')} / ${zipValue}`;
};

export const formatStreet = (street: string) => {
  if (!street) {
    return t('dash.common.aliases.n/a');
  }

  if (!isISR()) {
    return street;
  }

  const splitWords = street.split(' ');

  if (!/^\d+/.test(splitWords[0])) {
    return street;
  }

  const number = splitWords.shift();

  return (
    <div>
      <span>{splitWords.join(' ')} </span>
      <span>{number}</span>
    </div>
  );
};
